module.exports = __webpack_public_path__ + "img/arrow.fb28b1bd.png";